import {
  defaultFilterKeys,
  defaultLinearFilters,
  today,
  getCssColor,
  getGroupedData,
  defaultLinearOptions,
  defaultLinearDatasetOptions,
  getFormatedDate,
} from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {LinearChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'status_leads',
    resource: {
      endpoint: 'status_leads',
      sideeffects: ['sources_leads'],
      filter: {
        'filter.start': defaultFilterKeys[30],
        'filter.end': today(),
        'filter.statuses': ['sold', 'sale', 'reserved'],
        'filter.saleType': 'sale',
      },
    },
    type: 'Linear',
    filterBy: {
      initial: 30,
      label: context.$t('select'),
      key: 'filter.start',
      values: defaultLinearFilters.map(filter => ({ ...filter, label: context.$t(filter.label) })),
    },
    title: {
      id: 'leads_total',
      label: `${context.$tc('lead', 2)} ${context.$t('total').toLowerCase()}`,
      style: true,
    },
    total: ({ data = {} }) => ({ leads_total_full: data.total }),
    dimensions: [
      {
        id: 'leads_total_full',
        label: context.$t('leadsTotalFull'),
        icon: '',
        marker: getCssColor('primary'),
        backgroundColor: getCssColor('primary', 0.5),
        borderColor: getCssColor('primary'),
        value: ({ data = {} }) => {
          if (!data || !data.keys) return 0
          return data.keys.map(i => {
            const item = data.values[i]
            if (!item || !item.total) return 0
            return item.total
          })
        },
      },
      {
        id: 'leads_by_date',
        label: context.$t('leadsByDate'),
        icon: '',
        backgroundColor: getCssColor('error', 0.5),
        borderColor: getCssColor('error'),
        marker: getCssColor('error'),
        value: ({ data = {} }) => (data.keys ? data.keys.map(key => getGroupedData(data, key)) : []),
      },
    ],
    colors: {},
    options: ({ source }) => ({
      ...defaultLinearOptions({ source }),
    }),
    data: ({ data = {}, dimensions = [], source }) => {
      // TODO: Refactor so that this must not be implemented all places. This is default behavior
      // Default usage is dimensions? But labels must be added?
      // In component see if datasets is added if not use dimensions
      const labels = data.keys ? data.keys.map(key => getFormatedDate(key)) : []
      return {
        labels,
        datasets: dimensions.map(dimension => {
          return {
            ...defaultLinearDatasetOptions,
            data: dimension.value({ data, source, dimensions }) || null,
            backgroundColor: dimension.backgroundColor,
            borderColor: dimension.borderColor,
          }
        }),
      }
    },
  }
}
